import { render } from "./donation.vue?vue&type=template&id=7a7b3523&scoped=true"
import script from "./donation.vue?vue&type=script&lang=js"
export * from "./donation.vue?vue&type=script&lang=js"

import "./donation.vue?vue&type=style&index=0&id=7a7b3523&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7b3523"]])

export default __exports__